import { DateTime } from 'luxon';
import React from 'react'


interface TimeBlockProps {
  time: string;
}

const TimeGrid = (): JSX.Element => {
  const TimeBlock: React.FC<TimeBlockProps> = ({ time }) => {
    const now = DateTime.local();
    const givenTime = DateTime.fromFormat(time, 'ha');

    const timeIsCurrentHour = givenTime.hour === now.hour;
    return <div>
      <div className={`sticky left-0 z-20 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400 ${timeIsCurrentHour ? 'font-bold text-blue-500' : ''}`}>
        {time}
      </div>
    </div>;
  };

  const hours = [
    '12AM', '1AM', '2AM', '3AM', '4AM', '5AM', '6AM', '7AM', '8AM', '9AM',
    '10AM', '11AM', '12PM', '1PM', '2PM', '3PM', '4PM', '5PM', '6PM', '7PM',
    '8PM', '9PM', '10PM', '11PM'
  ];

  return (
    <>
      {hours.map((hour, index) => (
        <React.Fragment key={index}>
          <TimeBlock time={hour} />
          <div />
        </React.Fragment>
      ))}
    </>
  );
}

export default TimeGrid;
